import React, { useState, useEffect } from 'react';
import { FaCheckCircle } from "react-icons/fa";
import { IoCloseCircleSharp } from "react-icons/io5";
import { BeatLoader } from 'react-spinners';
import ApiRequestService from '../../../component/ApiRequestService';
import { NotificationManager } from 'react-notifications';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Box, Typography, Divider } from '@mui/material';
import { FaCheck } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { getDateFormat } from '../../../common/function';

const colorMap = {
    error: "#d32f2f",
    warning: "#ed6c02",
    success: "#2e7d32"
};


const SFUserDetailModal = ({ open, handleClose, userName, actionButtons }) => {

    const [userDetail, setUserDetail] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (open) {
            getUserDetail();
        } else {
            setUserDetail(null);
            setLoading(false);
        }
    }, [open])

    const getUserDetail = () => {
        setLoading(true);

        ApiRequestService({
            method: 'post',
            url: '/getUserDetail',
            data: {
                instructor_name: userName,
            }
        }).then(res => {
            if (res && res.data) {
                if (res.data.message) {
                    NotificationManager.error(res.data.message, "", 4000);
                } else {
                    if (res.data.data) {
                        setUserDetail(res.data.data);
                    }
                }
            }
        }).finally(() => {
            setLoading(false);
        })
    }

    const getApprovalStatus = (user) => {
        const map = {
            "-1": { text: "Rejected", color: "error" },
            "0": { text: "Pending", color: "warning" },
            "1": { text: "Approved", color: "success" }
        };

        const item = map[user.approval];
        if (!item) return null;

        return (
            <Typography fontSize={16} fontWeight={600} sx={{ color: colorMap[item.color] }}>
                {item.text}
            </Typography>
        );
    }

    return (
        <Dialog open={open}
            maxWidth='md'
            fullWidth
        >
            <DialogTitle>User Information</DialogTitle>
            {loading ? <center>
                <BeatLoader loading={true} color='#bb0000' />
            </center> :
                <DialogContent style={{ padding: 0 }} dividers>
                    <Box sx={{ background: "#666666", padding: '1rem', }}>
                        <Typography color="#fff" fontSize={18} fontWeight={600}>{userDetail?.firstName} {userDetail?.lastName}</Typography>
                        <Typography color="#fff" fontSize={14}>@{userName}</Typography>
                    </Box>
                    <Grid container spacing={2} sx={{ padding: '2rem' }}>

                        <InfoRow label="Active Status" value={userDetail?.active === 1 ? 
                            <div className='d-flex justify-center items-center'>
                                <FaCheckCircle color='green' fontSize={20} />
                                <div style={{marginLeft:'4px'}}>Active</div>
                            </div> : 
                            <div className='d-flex justify-center items-center gap-2'>
                                <IoCloseCircleSharp color='red' fontSize={20} />
                                <div style={{marginLeft:'4px'}}>In-Active</div>
                            </div>
                        } />
                        <InfoRow label="Approval Status" value={userDetail ? getApprovalStatus(userDetail) : null} />

                        {/* Personl Information */}
                        <Grid item xs={12}>
                            <Divider />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography fontSize={18} fontWeight={600}>Personal Information</Typography>
                        </Grid>

                        <InfoRow label="First Name" value={userDetail?.firstName} />
                        <InfoRow label="Last Name" value={userDetail?.lastName} />
                        <InfoRow label="Email" value={userDetail?.emailid} />

                        {/* Organization Information */}
                        <Grid item xs={12}>
                            <Divider />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography fontSize={18} fontWeight={600}>Institution Information</Typography>
                        </Grid>

                        <InfoRow label="Institution" value={userDetail?.organization ? userDetail?.organization : "N/A"} />
                        <InfoRow label="Position" value={userDetail?.position ? userDetail?.position : "N/A"} />
                        <InfoRow label="Verification Link" value={userDetail?.verificationLink ? userDetail?.verificationLink : "N/A"} />
                        <InfoRow label="Intended Use" value={userDetail?.intendedUse ? userDetail?.intendedUse : "N/A"} />

                        {/* Organization Information */}
                        <Grid item xs={12}>
                            <Divider />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography fontSize={18} fontWeight={600}>System Information</Typography>
                        </Grid>
                        <InfoRow label="SF ID" value={userDetail?.userID} />
                        <InfoRow label="Username" value={userName} />
                        <InfoRow label="Created At" value={userDetail?.createdAt ? getDateFormat(userDetail?.createdAt) : "N/A"} />
                        <InfoRow label="Created By" value={userDetail?.createdBy ? userDetail?.createdBy : "N/A"} />
                    </Grid>
                </DialogContent>
            }
            <DialogActions>
                <DialogActions>
                    {actionButtons}
                    <Button variant='outlined' onClick={handleClose}>Close</Button>
                </DialogActions>
            </DialogActions>
        </Dialog>
    );
}


const InfoRow = ({ label, value }) => {
    return (
        <Grid item xs={5}>
            <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ fontSize: 14, color: "#666" }}>{label}</span>
                <div style={{ fontWeight: 500, fontSize: '1rem' }}>
                    {value}  {/* Now works with Typography or icons */}
                </div>
            </div>
        </Grid>
    )
}


export default SFUserDetailModal;
